<template>
  <div class="list_components">
    <slot @scroll="onScroll"></slot>
    <div class="show_text" v-if="loading">{{loadingText}}</div>
    <div class="no_data_text" v-if="nodata">{{nodataText}}</div>
    <div class="show_text" v-if="finished">{{finishedText}}</div>
    <div class="show_text" v-if="hasError" @click="errorClick">{{errorText}}</div>
  </div>
</template>

<script>
  export default {
    name: "JcList",
    data() {
      return {
        scrollTop: 0, //滚动条距离顶部高度
        loading: false,
        nodata: false,
        finished: false,
        hasError: false,
        list: [],
        page: 1,
        nodataText: "暂无数据~",
        loadingText: "加载中…",
        finishedText: "我是有底线的~",
        errorText: "请求失败,点击重新加载"
      };
    },
    props: {
      url: {
        type: String
      },
      loads: {
        type: Object
      },
      offset: {
        type: Number,
        default: 50
      }
    },
    methods: {
      handleScroll() {
        let current_top =
          document.documentElement.scrollTop || document.body.scrollTop;
        let windowHeight =
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        let scrollHeight =
          document.documentElement.scrollHeight ||
          document.body.scrollHeight;
        let reachBottom = scrollHeight - current_top - windowHeight;
        if (reachBottom <= this.offset && !this.finished && !this.loading) {
          // 距离底部距离<=50时加载下一页
          this.getList(2);
        }
      },
      getList(page) {
        if (this.loading) {
          return false;
        }
        this.nodata = false;
        this.finished = false;
        this.hasError = false;
        this.loading = true;
        if (page !== 1) {
          this.loads.page = this.loads.page + 1;
        } else {
          this.loads.page = 1;
          this.list = [];
        }
        this.axios.post("/wechat.php" + this.url, this.loads).then(res => {
          this.loading = false;
          res = res.data;
          if (res.code == 1) {
            if (res.data.data_list.total == 0) {
              this.nodata = true;
            } else if (
              res.data.data_list.current_page >=
              res.data.data_list.last_page
            ) {
              this.finished = true;
            }
            if (res.data.data_list.data.length) {
              this.list = this.list.concat(res.data.data_list.data);
              this.$emit("load", this.list);
            } else {
              this.$emit("load", []);
            }
          } else {
            this.hasError = true;
          }
        });
      },
      errorClick() {
        this.$emit("load");
      }
    },
    watch: {
      loads: {
        handler(newVal, oldVal) {
          this.getList(1);
        },
        deep: true
      }
    },
    mounted() {
      this.getList(1);
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  };
</script>

<style lang="stylus" scoped>
  .list_components {
    margin-top: 20px;
  }

  .show_text {
    color: #ccc;
    font-size: 28px;
    text-align: center;
    line-height: 50px;
    height: 50px;
  }

  .no_data_text {
    color: #999;
    font-size: 28px;
    text-align: center;
    line-height: 50px;
    height: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/hzjc/list/Index.vue